<script setup lang="ts">
import { openHowGiftlyWorksModal } from '@consumer/services/modals'
import { landing } from '@consumer/api'

defineProps<{ trackNavLinkClick?: never }>()
</script>

<template>
  <a
    rel="nofollow"
    :href="landing.howItWorks.path()"
    @click.exact.prevent="openHowGiftlyWorksModal()"
  ><slot>How it Works</slot></a>
</template>
